import React from "react";

import classNames from "classnames";

const NodeIdBadge: React.FunctionComponent<{
  nodeId: number | string;
  highlighted?: boolean;
  className?: string;
}> = ({ nodeId, highlighted, className }) => {
  const baseStyle =
    "inline-block text-center h-[17px] leading-[17px] font-bold text-white text-[12px] rounded-sm px-[3px] min-w-[17px]";

  return (
    <span
      className={classNames(
        baseStyle,
        highlighted
          ? "bg-[var(--color-blue-500)]"
          : "bg-[var(--color-gray-700)]",
        className,
      )}
    >
      {nodeId}
    </span>
  );
};

export default NodeIdBadge;
